import { render, staticRenderFns } from "./ElevatorArchives.vue?vue&type=template&id=07e34f40&scoped=true"
import script from "./ElevatorArchives.vue?vue&type=script&lang=js"
export * from "./ElevatorArchives.vue?vue&type=script&lang=js"
import style0 from "./ElevatorArchives.vue?vue&type=style&index=0&id=07e34f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e34f40",
  null
  
)

export default component.exports